export default __webpack_public_path__ + "static/media/payment-box-icon-02.41dc2160.png";